const InternationalCooperationProjects = [
  {
    id:  "project-1",
    title: "Special Smiles and Gentle Care",
    thumbnail: "project-3/p3-1.heic",
    contentPath: "/project-content/SpecialSmilesAndGentleCare.md",
    description: "A collaborative oral health initiative by the Philippine Dental Association (PDA) Quezon Chapter, launched at a local elementary school.",
    division: "international-cooperation",
    IsFeatured: true,
    images: [
      {
        path: "project-3/p3-2.heic",
        aspect: "16/9"
      },
      {
        path: "project-3/p3-3.heic",
        aspect: "16/9"
      },
      {
        path: "project-3/p3-4.heic",
        aspect: "9/16"
      },
      {
        path: "project-3/p3-5.heic",
        aspect: "16/9"
      },
      {
        path: "project-3/p3-6.heic",
        aspect: "16/9"
      },
      {
        path: "project-3/p3-7.heic",
        aspect: "16/9"
      },
      {
        path: "project-3/p3-8.heic",
        aspect: "16/9"
      },
      {
        path: "project-3/p3-9.heic",
        aspect: "16/9"
      },
    ]
  },
]

export default InternationalCooperationProjects;